// Round 95p·10 (Feb 2026) — Single source of truth for
// dividend eligibility across the app.
//
// Mirrors backend `_is_dividend_eligible` / `_dividend_status` in
// server.py. Used by StockModal, StockSeoPage, and screener/search
// components so they classify REIT/BDC IPOs (like BXDC) consistently
// even before the first dividend declaration.
//
// Rules:
//   • pays_dividend === true      → paying
//   • dividend_yield > 0           → paying
//   • is_reit / is_bdc              → eligible_pending (legally required
//                                      to distribute 90% of taxable
//                                      income once operating; treat as
//                                      dividend UI even without a
//                                      declared yield)
//   • otherwise                    → non_dividend
//
// CEFs are NOT auto-flagged eligible_pending — most CEFs pay to
// maintain RIC tax status but there are legitimate edge cases
// (non-traded interval funds, some accumulating CEFs, brand-new
// pre-launch CEFs). Real CEF payers are caught by the yield check.

export function dividendStatus(stock) {
  if (!stock || typeof stock !== 'object') return 'non_dividend';
  // Ghost-dividend guard (Feb 2026) — a doc explicitly scrubbed by the
  // backend guard is inactive; do NOT re-elevate old REIT/BDC issuers
  // that stopped paying long ago just because of the structural flag.
  if (stock.effective_dividend_status === 'inactive') return 'non_dividend';
  if (stock.pays_dividend === true) return 'paying';
  if (typeof stock.dividend_yield === 'number' && stock.dividend_yield > 0) return 'paying';
  if (stock.is_reit || stock.is_bdc) return 'eligible_pending';
  return 'non_dividend';
}

export function isDividendEligible(stock) {
  return dividendStatus(stock) !== 'non_dividend';
}

// Short human copy for the "eligible but no first declaration yet"
// state, used inline (e.g. in a snapshot row where "Yes/No" used to sit).
export const PENDING_DECLARATION_LABEL = 'Awaiting first declaration';
